import React, { useState, useEffect } from "react";
import axios from "axios";
import { CheckCircle, Spinner, Tooltip, XCircle } from "@opendate-app/setlist";

const errorsContainerStyle = {
  alignItems: "center",
  color: "var(--sl-text-secondary)",
  display: "flex",
  flexDirection: "row",
  fontSize: "14px",
  gap: "8px",
};

const parseLiquid = async (template, sampleData, teamId, id, csrfToken) => {
  axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
  const response = await axios.post(`/teams/${teamId}/twilio_templates/${id}/parse_liquid`, {
    twilio_template: {
      template: template,
      sample_data: sampleData,
    }
  });
  return response.data;
};

const TwilioTemplateErrorsContainer = ({
  templatableContext,
}) => {
  const {
    csrfToken,
    team,
    template,
    to,
    sampleData,
    errors,
    setErrors,
    twilioTemplate,
    setProcessedTemplate,
    setProcessedTo,
  } = templatableContext();

  const [isParsing, setIsParsing] = useState(false);

  useEffect(() => {
    setIsParsing(true);
    const delayDebounce = setTimeout(() => {
      parseLiquid(template, sampleData, team.id, twilioTemplate.id, csrfToken).then(({ parsedText, liquidErrors }) => {
        setProcessedTemplate(parsedText || template);
        setErrors(liquidErrors);
        setIsParsing(false);
      });
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [template, sampleData]);

  useEffect(() => {
    setIsParsing(true);
    const delayDebounce = setTimeout(() => {
      parseLiquid(to, sampleData, team.id, twilioTemplate.id, csrfToken).then(({ parsedText, liquidErrors }) => {
        setProcessedTo(parsedText || to);
      });
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [to, sampleData]);

  return (
    isParsing ? (
      <Spinner size="sm" aria-label="Checking for template errors" />
    ) : (
      <div style={errorsContainerStyle}>
          {errors?.length > 0 ? (
            <Tooltip title="Liquid errors" supportingText={errors.map((error, index) => <div key={index}>{error}</div>)}>
              <span style={{ display: "inline-flex" }} tabIndex={0}>
                <XCircle width={18} height={18} color="var(--sl-fg-error)" aria-label="Template has errors" />
              </span>
            </Tooltip>
          ) : (
            <CheckCircle width={18} height={18} color="var(--sl-fg-success)" aria-hidden="true" />
          )}
          <div>
            {errors?.length || "No"} Errors
          </div>
      </div>
    )
  );
};

export default TwilioTemplateErrorsContainer;
